import {inject, Injectable} from '@angular/core'
import {OAuthService} from 'angular-oauth2-oidc'

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private readonly oauthService = inject(OAuthService)

  // Selectors
  get userIsConnected(): boolean {
    return this.oauthService.hasValidIdToken()
  }

  // Actions
  logOut(): void {
    this.oauthService.logOut({
      client_id: this.oauthService.clientId,
      redirect_uri: this.oauthService.redirectUri,
      response_type: 'code',
    })
  }

  connectUserIfNecessary(): boolean | Promise<boolean> {
    if (this.oauthService.hasValidAccessToken()) {
      console.log('Valid access token found. Access granted.');
      return true;
    }

    return this.oauthService.tryLogin().then(success => {
      const currentUrl = window.location.href
      if (success && this.oauthService.hasValidAccessToken()) {
        console.log('Login successful via tryLogin. Navigation allowed.');
        if (this.oauthService.state && currentUrl !== decodeURIComponent(this.oauthService.state)) {
          window.location.href = decodeURIComponent(this.oauthService.state)
        }
        return true;
      } else {
        console.log('tryLogin failed. Initiating a new login flow.');
        this.oauthService.initLoginFlow(currentUrl);
        return false;
      }
    });
  }

}
